import { FC, Suspense } from "react";
import { Box, LinearProgress } from "@mui/material";

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

import LeftNavMenu from "./LeftNavMenu";
import SharePageFormDialog from "components/form/SharePageFormDialog";
import ErrorBoundaryProvider from "providers/ErrorBoundaryProvider";

const LeftNavContent: FC<{ simpleBarHeight: number }> = ({ simpleBarHeight }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <SimpleBar style={{ height: simpleBarHeight }}>
        <LeftNavMenu />
      </SimpleBar>
      {/* [ToDo] 以下の SharePageFormDialog は、他でも使ってる（上書き保存）ので、LeftNav に置いてるのは少し変。共通部分に移植すべき。 */}
      <ErrorBoundaryProvider>
        <Suspense fallback={<LinearProgress sx={{ opacity: 0.3 }} />}>
          <SharePageFormDialog />
        </Suspense>
      </ErrorBoundaryProvider>
    </Box>
  );
};

export default LeftNavContent;
